module.exports = __webpack_public_path__ + "static/media/money.70553032.png";